
<template>
    <v-container fluid>   
      <LeftMenu/> 
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="personnelRatings"
              :items-per-page="50"
              item-key="id"
              sort-by="name"
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              hide-default-footer
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Personnel Ratings</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <span>
                    <v-combobox
                        :items="periodList"
                        label="Select Performance Period"
                        item-text="text"
                        single-line
                        return-object
                        v-on:change="performancePeriodChanged"
                    ></v-combobox>
                  </span>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="1200px">                    
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }} - {{editedItem.personnelFullname}}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout row>                                
                            
                            <v-flex xs12 sm4 md4>
                              <v-text-field 
                                :key="criteriaItem.criteriaId"
                                v-for="criteriaItem in editedItem.ratings"
                                v-model="criteriaItem.criteria" 
                                disabled label=""></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm8 md8>
                              <v-radio-group 
                                row
                                v-model="editedItem.ratings[criteriaItem.orderNo].rating"
                                :key="criteriaItem.criteriaId"
                                v-for="criteriaItem in editedItem.ratings">
                                    <v-radio
                                    v-for="n in 10"
                                    :key="n"
                                    :label="`${n}`"
                                    :value="n"
                                    ></v-radio>
                                    <v-icon                  
                                      @click="editedItem.ratings[criteriaItem.orderNo].rating = 0">
                                      mdi-delete
                                    </v-icon>
                              </v-radio-group>                              
                            </v-flex>                                                                                                                                                                                                                             
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.personnelRatingsActions="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>               
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
const API_URL = 'personnelRatings';
const CURRENCIES_API_URL = 'definitions/currencies';
const PERIODS_API_URL = 'definitions/periods';
export default {
    components:{
      LeftMenu,
      DatePicker
    },
    data () {
    return {
      dialog: false,
      search: '',
      periodList: [],
      currencyList: [],
      currentUserId: '',
      personnelRatings: [
        {     
          reviewerId: '',        
        },               
      ],
      selectedPeriod: -1,
      editedIndex: -1,
      editedItem: {
        model: '',
          reviewerId: '',
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      }
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Personnel Fullname',align: 'left',sortable: true,value: 'personnelFullname' },        
        { text: 'Rating Avg.',  value: 'ratingAvarage'  },                   
        { text: 'Actions', value: 'personnelRatingsActions', sortable: false },
      ]
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Personnel Rating' : 'Edit Personnel Rating'
    },
  },
  created() {    
    this.getPerformancePeriodList();
    //this.getCurrencies();
    //this.getPersonnelRatigs();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  beforeMount() {
      if (localStorage.user_id) {
        this.currentUserId = localStorage.getItem('user_id');
      }
    },
  methods: {
    performancePeriodChanged(item){        
      this.selectedPeriod = item.id;
      this.getPersonnelRatigs(item.id,this.currentUserId);
    },
    editItem (item) {         
      this.editedIndex = this.personnelRatings.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      if(confirm('Are you sure you want to delete this item?')){
        this.deletePersonnelRating(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updatePersonnelRating(this.editedItem);
      } else {
        this.addPersonnelRating(this.editedItem);         
      }      
    },
    addPersonnelRating(item){
      this.$axios.post(this.$apiurl + API_URL, {
        currencyId: item.currency.id,
        categoryId: item.category.id,
        amount: item.amount,
        personnelRatingDate:item.personnelRatingDate,
        explanation: item.explanation
      })
      .then(response => {        
        if (response.status === 201) {
          this.personnelRatings.push(this.editedItem);
          this.$radio.$emit('success', {message:'Personnel Rating Added Successfully'});
          this.getPersonnelRatigs(this.selectedPeriod,this.currentUserId);
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updatePersonnelRating(item){
      this.$axios.put(this.$apiurl + API_URL, {        
        ratingPeriodId: this.selectedPeriod,        
        personnelId: item.personnelId,
        reviewerId:item.reviewerId,
        ratings: item.ratings
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.personnelRatings[this.editedIndex], this.editedItem);        
          this.$radio.$emit('success', {message:'Personnel Rating Updated Successfully'});  
          this.getPersonnelRatigs(this.selectedPeriod,this.currentUserId);
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deletePersonnelRating(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
        if (response.status === 200) {
          const index = this.personnelRatings.indexOf(item);
          this.personnelRatings.splice(index, 1);
          this.$radio.$emit('success', {message:'Personnel Rating Deleted Successfully'});
          this.getPersonnelRatigs(this.selectedPeriod,this.currentUserId);
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getPersonnelRatigs(period, reviewer){     
        this.$axios.get(this.$apiurl + API_URL+'/'+period+'/'+reviewer)
            .then(response => {
                this.personnelRatings = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },    
    getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl + PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
